(function() {
  'use strict';

  /**
   * @ngdoc object
   * @name crewCreditHoursReport.controller:crewCreditHoursReportCtrl
   *
   * @description
   *
   */
  angular.module('crewCreditHoursReport').controller('crewCreditHoursReportCtrl',
    crewCreditHoursReportCtrl);

  function crewCreditHoursReportCtrl(CommonMasterData, $sce, CommonLogicService,crewCreditHoursReportService) {
    var vm = this;
    vm.ctrlName = 'crewCreditHoursReportCtrl';
    vm.model = {
      searchPanelToggle : true,
      searchCriteria : {
        fromDate : null,
        toDate : null,
        crewType : null,
        creName : null,
        crewId : null,
        status :{title:'All', value: 'ALL'}
      },
      masterList : {
        crewTypes : [],
        crewNames : [],
        statusList : [
          {title:'Active', value: 'ACT'},
          {title:'Inactive', value: 'INA'},
          {title:'All', value: 'ALL'}
        ],
        fromDateFormatInvalid : false,
        toDateFormatInvalid : false,
        fromDateAfterToDate : false,
        isToDateFutureDate : false,
        isNeitherCrewTypeOrCrewIdSelected : false
      },
      initialSearchDone : false,
      reportDataURL : null,
      reportServerBaseUrl : null
    };

    // toggle search
    vm.clickOnSearch = function() {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    // submit search
    vm.submitSearch = function(params) {
      searchCrewCreditHoursReport(params);
    };

    // on change search field
    vm.changeSearchField = function(searchParams, flag) {
      setDateValidationFlags();
      switch (flag) {
        case "CREW_TYPE":
          setCrewName();
          break;
        case "crewName":
          vm.model.searchCriteria.crewId = searchParams.crewName.crewId;
          break;
      }
      if (!vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromDateFormatInvalid
        && !vm.model.masterList.isToDateFutureDate) {
        if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
        } else {
          vm.model.masterList.fromDateAfterToDate = false;
        }
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }

      if ((flag == 'crewId' || flag == 'crewType') && !vm.model.masterList.fromDateFormatInvalid
        && !vm.model.masterList.toDateFormatInvalid && !vm.model.masterList.fromDateAfterToDate){
        if ((!!vm.model.searchCriteria.crewType
          && !!vm.model.searchCriteria.crewType.crewTypeCode) || !!vm.model.searchCriteria.crewId) {
          vm.model.masterList.isNeitherCrewTypeOrCrewIdSelected = false;
        } else {
          vm.model.masterList.isNeitherCrewTypeOrCrewIdSelected = true;
        }
      }
    };
    function setCrewName(){
      var data = vm.model.searchCriteria.crewType;

      if(data == null || data.crewTypeCode == null){
        return;
      }

      vm.model.masterList.crewNames = null;
      vm.model.searchCriteria.crewName = null;
      crewCreditHoursReportService.searchCrewNamesByCrewType(data,
        function(crewNames){
          vm.model.masterList.crewNames = crewNames;
        },
        function(error){
          MessageService.error(error);
        }
      );
    }
    function setDateValidationFlags() {
      // if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }

      // if to date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
        vm.model.masterList.isToDateFutureDate = false;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
        if (!!vm.model.searchCriteria.toDate) {
          vm.model.masterList.isToDateFutureDate = istoDateFutureDate();
        } else {
          vm.model.masterList.isToDateFutureDate = false;
        }
      }
    }

    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    // check from date and to date
    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    }
    ;

    // check to date is a future date
    function istoDateFutureDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isAfter(moment().toDate());
    }
    ;

    // search Crew Water Consumption Report
    function searchCrewCreditHoursReport(param) {
      vm.model.initialSearchDone = true;
      if (isValidSearchParams(param)) {
        vm.model.searchCriteria = param;
        vm.model.searchPanelToggle = false;
        var reportDesign = "individual_crew_credit_hours_detailed_per_flight.rptdesign"; //design file name
        var url = CommonLogicService.getReportUrl(reportDesign,
          getSearchParamMap(param));
        vm.model.reportDataURL = $sce.trustAsResourceUrl(url);

      }
    }

    // set search param map
    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["from_date"] = param.fromDate;
      searchParamMap["to_date"] = param.toDate;
      if (!!param.crewId) {
        searchParamMap["crew_id"] = param.crewId;
      }
      if (!!param.crewType && !!param.crewType.crewTypeCode) {
        searchParamMap["crew_type"] = param.crewType.crewTypeCode;
      }
      if (!!param.status && !!param.status.value){
        searchParamMap["status"] = param.status.value;
      }
      return searchParamMap;
    }

    function isValidSearchParams(params) {
      setDateValidationFlags();
      // if date invalid
      if (vm.model.masterList.toDateFormatInvalid
        || vm.model.masterList.fromDateFormatInvalid
        || vm.model.masterList.isToDateFutureDate) {
        return false;
      } else if (istoDateBeforeFromDate()) {
        vm.model.masterList.fromDateAfterToDate = true;
        return false;
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
        if ((!!vm.model.searchCriteria.crewType
          && !!vm.model.searchCriteria.crewType.crewTypeCode) || !!vm.model.searchCriteria.crewId) {
          vm.model.masterList.isNeitherCrewTypeOrCrewIdSelected = false;
          return true;
        }
        vm.model.masterList.isNeitherCrewTypeOrCrewIdSelected = true;
        return false;
      }
    }

    ( // load crew Types
      function loadCrewTypes() {
        CommonMasterData.getCrewTypeList(function(crewTypes) {
          vm.model.masterList.crewTypes = crewTypes;
        }, function() {
          console.log('Crew type retrieval error');
        });
      })();




  }
}());

